<div class="outer-container">

  <div class="permissions-title">
    {{ heading }}
  </div>

  <div class="switches-header">
    <div></div>
    <div class="checkbox-container read-write-header">
      {{ 'READ' }}
    </div>
    <div class="checkbox-container read-write-header">
      {{ 'WRITE' }}
    </div>
  </div>

  <div class="switches-container" #scrollContainer
    [ngClass]="{'invalid': touched && requireAtLeastOneChecked}">

    @for (switchGroup of switchGroups; track switchGroup) {
      <div #sg class="switch-group-container" (mousedown)="onSwitchGroupMouseUp(sg, scrollContainer)">
        <lib-multi-stage-expansion-panel [midStageSizesInPixels]="[50]" [stage]="switchGroup.open ? 2 : 1">
          <div class="switch-group-container-inner">
            <div class="switch-group-line-one">
              <div class="switch-group-title">
                {{ switchGroup.name }}
              </div>
              <div class="checkbox-container">
                @if (switchGroupHasPermissionsWhichRead(switchGroup)) {
                  <mat-checkbox #cbRead
                    class="custom-checkbox"
                    [checked]="switchGroupReadCheckboxChecked(switchGroup)"
                    [indeterminate]="switchGroupReadCheckboxIndeterminate(switchGroup)"
                    (change)="onReadCheckboxChanged(switchGroup, cbRead.checked)"
                    [disabled]="_readonly">
                  </mat-checkbox>
                }
              </div>
              <div class="checkbox-container">
                @if (switchGroupHasPermissionsWhichWrite(switchGroup)) {
                  <mat-checkbox #cbWrite
                    class="custom-checkbox"
                    [checked]="switchGroupWriteCheckboxChecked(switchGroup)"
                    [indeterminate]="switchGroupWriteCheckboxIndeterminate(switchGroup)"
                    (change)="onWriteCheckboxChanged(switchGroup, cbWrite.checked)"
                    [disabled]="_readonly">
                  </mat-checkbox>
                }
              </div>
              <div>
                @if (!switchGroup.open) {
                  <lib-action-button
                    [kind]="ActionButtonKind.FILTER"
                    fontImage="far fa-chevron-down"
                    (click)="setSwitchGroupOpen(switchGroup, true)">
                  </lib-action-button>
                } @else {
                  <lib-action-button
                    [kind]="ActionButtonKind.FILTER"
                    fontImage="far fa-chevron-up"
                    (click)="setSwitchGroupOpen(switchGroup, false)">
                  </lib-action-button>
                }
              </div>
            </div>
            @for (switch of orderedSwitchesForGroup(switchGroup); track switch) {
              <div class="switch-group-line-two">
                <div class="switch-title">
                  {{ switch.name }}
                </div>
                <div class="checkbox-container">
                  @if (!switch.writable) {
                    <mat-checkbox #cbR class="custom-checkbox" [checked]="switch.checked"
                      (change)="onCheckboxChanged(switch, cbR.checked)" [disabled]="_readonly">
                    </mat-checkbox>
                  }
                </div>
                <div class="checkbox-container">
                  @if (switch.writable) {
                    <mat-checkbox #cbW class="custom-checkbox" [checked]="switch.checked"
                      (change)="onCheckboxChanged(switch, cbW.checked)" [disabled]="_readonly">
                    </mat-checkbox>
                  }
                </div>
                <div></div>
              </div>
            }
          </div>
        </lib-multi-stage-expansion-panel>
      </div>
    }

  </div>

  <div class="switches-error">
    @if (touched && requireAtLeastOneChecked) {
      <mat-error>
        {{ errorMessageAtLeastOneRequired }}
      </mat-error>
    }
  </div>

</div>
